var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIgnoreConversationWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icIgnoreConversation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-36.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icIgnoreConversation",
    transform: "translate(37.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4833815,26.0384615 C19.5447697,26.0384615 19.6068863,26.0235899 19.6628641,25.9939485 C19.7856406,25.929369 19.8621158,25.8033676 19.8621158,25.6675875 L19.8621158,20.3840846 C23.1781216,18.6960527 25,15.740571 25,12.0375352 C25,6.31491169 19.6265514,2 12.5,2 C5.37344865,2 -1.0658141e-14,6.31491169 -1.0658141e-14,12.0375352 C-1.0658141e-14,17.7593438 5.37344865,22.0742555 12.5,22.0742555 C12.7341077,22.0742555 12.9636373,22.0617266 13.1938953,22.049809 L13.2090863,22.0490959 L19.2750776,25.9768359 C19.3379225,26.017682 19.410652,26.0384615 19.4833815,26.0384615 Z M0.5,23.5 L23.5,0.5",
    id: "Combined-Shape",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,24.5 L23.5,1.5",
    id: "Line-5",
    stroke: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIgnoreConversationWhite);
export default __webpack_public_path__ + "static/media/icIgnoreConversationWhite.d1fa51168baab3454030287f735401fb.svg";
export { ForwardRef as ReactComponent };